export const environment = {
  production: false,
  env: "dev",
  apiEndpoint: 'https://api.dev.crm.manubhoomi.info',

  //set if current API DB is dummy or not
  isDummyDataSource: false,
  dummyAPIUrl: "http://localhost:3000",

  decumentVerificationSource: 'deepvue',
  deepVueAPIUrl: 'https://production.deepvue.tech/v1/',
  assetsImagePath: "assets/images/",
  blobStorageUrl: 'https://manubhoomistrg.blob.core.windows.net/dev/'
};

